var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 96,
    viewBox: "0 0 78 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_4547_265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.2305 2.11914H15.9668C8.31503 2.11914 2.11206 8.34155 2.11206 16.0173V89.9148C2.11206 97.5905 8.31503 103.813 15.9668 103.813H72.2305C79.8822 103.813 86.0852 97.5905 86.0852 89.9148V16.0173C86.0852 8.34155 79.8822 2.11914 72.2305 2.11914Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0987 58.3475C52.1237 58.3475 58.6292 51.8216 58.6292 43.7714C58.6292 35.7213 52.1237 29.1953 44.0987 29.1953C36.0737 29.1953 29.5681 35.7213 29.5681 43.7714C29.5681 51.8216 36.0737 58.3475 44.0987 58.3475Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9767 76.7379C32.8628 72.882 38.185 70.4668 44.0986 70.4668C50.0122 70.4668 55.3344 72.882 59.2205 76.7379",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.11206 32.373H12.7988",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.11206 73.5586H12.7988",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4547_265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPerson);
export default __webpack_public_path__ + "static/media/contact-person.183c5ec843d1fbbed9176813c9434ce5.svg";
export { ForwardRef as ReactComponent };